import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f611bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "day-streak-modal__summary" }
const _hoisted_2 = { class: "day-streak-modal__summary-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total time focused:", -1))
const _hoisted_4 = { class: "day-streak-modal__summary-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total tasks:", -1))
const _hoisted_6 = { class: "day-streak-modal__summary-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total projects:", -1))
const _hoisted_8 = { class: "day-streak-modal__section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "day-streak-modal__section-title" }, " Tasks of the day: ", -1))
const _hoisted_10 = { class: "day-streak-modal__list" }
const _hoisted_11 = {
  key: 1,
  class: "day-streak-modal__empty"
}
const _hoisted_12 = { class: "day-streak-modal__section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "day-streak-modal__section-title" }, " Projects worked in this day: ", -1))
const _hoisted_14 = { class: "day-streak-modal__badges" }
const _hoisted_15 = {
  key: 1,
  class: "day-streak-modal__empty"
}

import { ref, computed } from 'vue';
import { useFormatSecondsToNow } from '@/composables/formatTime';
import FocusSummary from '@/interfaces/FocusSummary.interface';

import DSModal from '@/design-system/DSModal.vue';
import DSBadge from '@/design-system/DSBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DayStreakModal',
  setup(__props, { expose: __expose }) {

const show_modal = ref(false);
const selectedDate = ref('');
const focusedSummary = ref({} as FocusSummary);

const openModal = ({ selected_date, focused_summary }: { selected_date: string, focused_summary: FocusSummary }) => {
  selectedDate.value = selected_date;
  focusedSummary.value = focused_summary;
  show_modal.value = true;
};

const getFormattedDuration = computed(() => {
  return useFormatSecondsToNow({ seconds: focusedSummary.value.totalFocusTime });
});

const getFormattedDate = computed(() => {
  if (selectedDate.value) {
    let [year, month, date] = selectedDate.value.split('-');
    month = (+month + 1).toString().padStart(2, '0');
    date = date.padStart(2, '0');
    return `${date}/${month}/${year}`;
  }

  const current_date = new Date();
  return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`;
});

__expose({
  openModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show_modal).value = $event)),
    title: `Day: ${getFormattedDate.value}`,
    "has-footer": false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(getFormattedDuration.value), 1)
        ]),
        _createElementVNode("p", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(focusedSummary.value.totalTasks), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(focusedSummary.value.totalProjects), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          (focusedSummary.value.tasks.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(focusedSummary.value.tasks, (task) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: task.id
                }, [
                  _createElementVNode("span", null, _toDisplayString(task.description), 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_11, " Not found tasks for this day "))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (focusedSummary.value.projects.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(focusedSummary.value.projects, (project) => {
                return (_openBlock(), _createBlock(DSBadge, {
                  key: project.name,
                  label: project.name,
                  variant: "secondary"
                }, null, 8, ["label"]))
              }), 128))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, " Not found projects for this day "))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})